import React, { Component } from 'react';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import BibliothequePlotly from '../BibliothequePlotly/BibliothequePlotly';
import { convertiUtsToDate } from '../GrapheXT/GrapheXT';

function getWeek(date) {
  // We have to compare against the first monday of the year not the 01/01
  // 60*60*24*1000 = 86400000
  // 'onejan_next_monday_time' reffers to the miliseconds of the next monday after 01/01
  let day_miliseconds = 86400000,
    onejan = new Date(date.getFullYear(), 0, 1, 0, 0, 0),
    onejan_day = onejan.getDay() === 0 ? 7 : onejan.getDay(),
    days_for_next_monday = 8 - onejan_day,
    onejan_next_monday_time =
      onejan.getTime() + days_for_next_monday * day_miliseconds,
    // If one jan is not a monday, get the first monday of the year
    first_monday_year_time =
      onejan_day > 1 ? onejan_next_monday_time : onejan.getTime(),
    this_date = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0
    ), // This at 00:00:00
    this_time = this_date.getTime(),
    days_from_first_monday = Math.round(
      (this_time - first_monday_year_time) / day_miliseconds
    );

  return days_from_first_monday >= 0 && days_from_first_monday < 364
    ? Math.ceil((days_from_first_monday + 1) / 7)
    : 52;
}

const getWeekNumberForPlotlyDate = (plotlyDate) => {
  const listeDate = plotlyDate.split('-');
  let currentdate = new Date(
    listeDate[0],
    parseInt(listeDate[1]) - 1,
    listeDate[2]
  );
  return getWeek(currentdate);
};

function dateDiff(date1Plotly, date2Plotly) {
  let date1 = new Date(date1Plotly);
  let date2 = new Date(date2Plotly);
  let tmp = date2 - date1;

  tmp = Math.floor(tmp / 1000 / 60 / 60 / 24); // Nombre de jours restants

  return tmp;
}

function average(nums) {
  if (nums !== undefined && nums.length > 0) {
    return (nums.reduce((a, b) => a + b) / nums.length).toPrecision(2);
  } else return null;
}

class GrapheAvancementDetaille extends Component {
  state = {
    data: [],
    layout: {},
    dateSelectionne: '',
    valeurSelectionne: '',
    xAxisSelectionne: '',
    indSelectionne: '',
    prevDateSelectionne: '',
    prevXAxisSelectionne: '',
  };

  componentDidMount() {
    // todo: filtre par:
    // - période (date début/fin)
    // - avancement: portion sur une distance parcourus (distance min/max parcourus)
    // - tunnel meter: ?

    let data = {
      x: [
        '2021-06-01 01:00',
        '2021-06-01 02:00',
        '2021-06-01 03:00',
        '2021-06-01 04:00',
        '2021-06-01 05:00',
        '2021-06-01 06:00',
        '2021-06-01 07:00',
        '2021-06-01 08:00',
        '2021-06-01 09:00',
        '2021-06-01 10:00',
        '2021-06-01 11:00',
      ],
      y: [
        130.58, 13.58, 13.58, 13.58, 13.58, 15.55, 15.56, 15.55, 15.55, 16.48,
      ],
    };
    if (this.props.donnees !== undefined) {
      data.x = [...convertiUtsToDate(this.props.donnees[0].x)];
      data.y = [...this.props.donnees[0].y];
    }
    let dataParJourX = [];
    let dataParJourY = [];
    let dataParJourProgressionY = [];
    //Formatage de données
    let longueurListeLaPlusCourte;
    if (data.x.length <= data.y.length) {
      longueurListeLaPlusCourte = data.x.length;
    } else {
      longueurListeLaPlusCourte = data.y.length;
    }
    let progressionJournaliere = Math.round(data.y[0]); //valeur par défaut (commence le forage à l'état initiale 0)

    let premierJourDeLaSemaine = data.x[0];
    let dataParSemaineX = [];
    let dataParSemaineY = [];
    let dataParSemaineProgressionY = [];
    let progressionHebdomadaire = Math.round(data.y[0]); //valeur par défaut (commence le forage à l'état initiale 0)

    let dataParMoisX = [];
    let dataParMoisY = [];
    let dataParMoisProgressionY = [];
    let progressionMensuelle = Math.round(data.y[0]); //valeur par défaut (commence le forage à l'état initiale 0)
    for (let i = 0; i < longueurListeLaPlusCourte; i++) {
      if (i + 1 < longueurListeLaPlusCourte) {
        //Formatage de données -> données journaliére
        const dateI = data.x[i].split(' ')[0];
        const dateJ = data.x[i + 1].split(' ')[0];
        if (dateI !== dateJ && Math.round(data.y[i]) > progressionJournaliere) {
          //date en omettant l'heure
          dataParJourX.push(dateI); //date sans les heures
          //données brute (cumulative) par jour
          dataParJourY.push(Math.round(data.y[i])); //arrondi à l'entier
          //données par jour relative au jour précédent
          dataParJourProgressionY.push(
            Math.round(data.y[i]) - progressionJournaliere
          );
          progressionJournaliere = Math.round(data.y[i]);
        }

        //Formatage de données -> données Hebdomadaires
        const jourI = data.x[i].split(' ')[0];
        const semaineI = getWeekNumberForPlotlyDate(jourI);
        const semaineJ = getWeekNumberForPlotlyDate(
          data.x[i + 1].split(' ')[0]
        );
        if (
          semaineI !== semaineJ &&
          Math.round(data.y[i]) > progressionHebdomadaire
        ) {
          //date en omettant l'heure
          // dataParSemaineX.push("Semaine "+semaineI)//par semaine
          dataParSemaineX.push(premierJourDeLaSemaine); //date sans les heures
          //données brute (cumulative) par semaine
          dataParSemaineY.push(Math.round(data.y[i])); //arrondi à l'entier
          //données par mois relative au jour précédent
          dataParSemaineProgressionY.push(
            Math.round(data.y[i]) - progressionHebdomadaire
          );
          progressionHebdomadaire = Math.round(data.y[i]);

          premierJourDeLaSemaine = data.x[i + 1].split(' ')[0];
        }

        //Formatage de données -> données mensuelles
        const moisI = data.x[i].split(' ')[0].substring(0, 7);
        const moisJ = data.x[i + 1].split(' ')[0].substring(0, 7);
        if (moisI !== moisJ && Math.round(data.y[i]) > progressionMensuelle) {
          //date en omettant l'heure
          dataParMoisX.push(moisI + '-01'); //date sans les heures ni les jours
          //données brute (cumulative) par mois
          dataParMoisY.push(Math.round(data.y[i])); //arrondi à l'entier
          //données par mois relative au jour précédent
          dataParMoisProgressionY.push(
            Math.round(data.y[i]) - progressionMensuelle
          );
          progressionMensuelle = Math.round(data.y[i]);
        }
      } else {
        dataParJourX.push(data.x[i].split(' ')[0]); //date sans les heures
        dataParJourY.push(Math.round(data.y[i]));
        dataParJourProgressionY.push(
          Math.round(data.y[i] - progressionJournaliere)
        );

        dataParSemaineX.push(premierJourDeLaSemaine.split(' ')[0]); //date sans les heures
        dataParSemaineY.push(Math.round(data.y[i]));
        dataParSemaineProgressionY.push(
          Math.round(data.y[i] - progressionHebdomadaire)
        );

        dataParMoisX.push(data.x[i].split(' ')[0].substring(0, 7) + '-01'); //date sans les heures ni les jours
        dataParMoisY.push(Math.round(data.y[i]));
        dataParMoisProgressionY.push(
          Math.round(data.y[i] - progressionMensuelle)
        );
      }
    }
    const dataJournalier = {
      x: dataParJourX,
      y: dataParJourY,
    };
    const dataProgressionJournalier = {
      x: dataParJourX,
      y: dataParJourProgressionY,
    };
    const dataHebdomadaire = {
      x: dataParSemaineX,
      y: dataParSemaineY,
    };
    const dataProgressionHebdomadaire = {
      x: dataParSemaineX,
      y: dataParSemaineProgressionY,
    };
    const dataMensuel = {
      x: dataParMoisX,
      y: dataParMoisY,
    };
    const dataProgressionMensuel = {
      x: dataParMoisX,
      y: dataParMoisProgressionY,
    };

    let courbeHistogrammeJournalier = {
      ...dataProgressionJournalier,
      yaxis: 'y4',
      type: 'bar',
      name: 'HistogrammeJournalier',
      marker: {
        color: 'rgb(238, 173, 1)', //couleur des histogramme
        opacity: 0.7,
      },
    };
    let courbeJour = {
      ...dataJournalier,
      type: 'scatter',
      name: 'ProgressionJournalière',
      fill: 'tozeroy',
      stackgroup: 'one',
      fillcolor: 'rgba(180, 180, 180, 0.3)', // couleur de l'aire sous la courbe
      marker: {
        color: 'rgb(180, 180, 180)', // couleur de la courbe
        opacity: 0.7,
      },
    };
    let courbeHistogrammeHebdomadaire = {
      ...dataProgressionHebdomadaire,
      xaxis: 'x2',
      yaxis: 'y5',
      type: 'bar',
      name: 'HistogrammeHebdomadaire',
      marker: {
        color: 'rgb(238, 173, 1)',
        opacity: 0.7,
      },
    };
    let courbeSemaine = {
      ...dataHebdomadaire,
      xaxis: 'x2',
      yaxis: 'y2',
      type: 'scatter',
      name: 'ProgressionHebdomadaire',
      fill: 'tozeroy',
      stackgroup: 'one',
      fillcolor: 'rgba(180, 180, 180, 0.3)', // couleur de l'aire sous la courbe
      marker: {
        color: 'rgb(180, 180, 180)', // couleur de la courbe
        opacity: 0.7,
      },
    };
    let courbeHistogrammeMensuel = {
      ...dataProgressionMensuel,
      xaxis: 'x3',
      yaxis: 'y6',
      type: 'bar',
      name: 'HistogrammeMensuel',
      marker: {
        color: 'rgb(238, 173, 1)',
        opacity: 0.7,
      },
    };
    let courbeMois = {
      ...dataMensuel,
      xaxis: 'x3',
      yaxis: 'y3',
      type: 'scatter',
      name: 'ProgressionMensuelle',
      fill: 'tozeroy',
      stackgroup: 'one',
      fillcolor: 'rgba(180, 180, 180, 0.3)', // couleur de l'aire sous la courbe
      marker: {
        color: 'rgb(180, 180, 180)', // couleur de la courbe
        opacity: 0.7,
      },
    };

    const distanceFinale =
      this.props.viewobj_json_content === undefined ||
      this.props.viewobj_json_content.distanceFinale === undefined
        ? 2408
        : this.props.viewobj_json_content.distanceFinale;
    const distanceParcourus = Math.max(...dataJournalier.y);

    let gaugeDeProgression = {
      domain: { x: [0, 0.34], y: [0.74, 1] },
      value: distanceParcourus,
      type: 'indicator',
      mode: 'gauge+number',
      xaxis: 'x4',
      yaxis: 'y4',
      title: { text: 'Progression', align: 'left' },
      number: {
        // font:{
        //   size:16
        // },
        // prefix: "<span style={fontSize='50px'}>5%</span><br>",
        // suffix:" m"
        prefix: '<br>',
        suffix: ' m',
      },
      gauge: {
        axis: { range: [0, distanceFinale] }, //distance finale arrondie pour voir le trait rouge final
        // steps: [ //todo: information de phase
        //   { range: [0, 250], color: "lightgray" },
        //   { range: [250, 400], color: "gray" }
        // ],
        // threshold: { //todo: voir s'il y a une utilité (limite à atteindre)
        //   line: { color: "red", width: 4 },
        //   thickness: 0.75,
        //   value: 490
        // }
      },
    };

    //recherche des maximuns
    const maxDataParJourProgressionY = Math.max(...dataParJourProgressionY);
    const maxDataParSemaineProgressionY = Math.max(
      ...dataParSemaineProgressionY
    );
    const maxDataParMoisProgressionY = Math.max(...dataParMoisProgressionY);
    //calcul des moyennes
    const moyenDataParJourProgressionY = average(dataParJourProgressionY);
    const moyenDataParSemaineProgressionY = average(dataParSemaineProgressionY);
    const moyenDataParMoisProgressionY = average(dataParMoisProgressionY);

    //Tableaux de maximuns et de moyennes
    let values = [
      [checkMot('mensuel'), checkMot('hebdomadaire'), checkMot('journalier')],
      [
        maxDataParMoisProgressionY,
        maxDataParSemaineProgressionY,
        maxDataParJourProgressionY,
      ],
      [
        moyenDataParMoisProgressionY,
        moyenDataParSemaineProgressionY,
        moyenDataParJourProgressionY,
      ],
    ];
    let table = {
      layout: {
        width: 500,
        height: 500,
      },
      domain: {
        x: [0, 0.34],
        y: [0.3, 0.64],
      },
      type: 'table',
      header: {
        values: [[''], ['<b>Max</b> [m]'], ['<b>Moyen</b> [m]']],
        align: 'center',
        line: { width: 1, color: 'black' },
        fill: { color: 'grey' },
        font: { family: 'Arial', size: 12, color: 'white' },
      },
      cells: {
        values: values,
        align: 'center',
        line: { color: 'black', width: 1 },
        font: { family: 'Arial', size: 11, color: ['black'] },
      },
    };

    data = [
      courbeHistogrammeJournalier,
      courbeJour,
      courbeHistogrammeHebdomadaire,
      courbeSemaine,
      courbeHistogrammeMensuel,
      courbeMois,
      gaugeDeProgression,
      table,
    ];

    let layout = {
      title: {
        text: 'Avancement du tunnelier - RTE MESIL',
        font: {
          // family: 'Courier New, monospace',
          size: 24,
        },
      },
      yaxis1: { domain: [0, 0.3], anchor: 'x1', side: 'right' },
      yaxis4: {
        domain: [0, 0.3],
        anchor: 'x1',
        visible: false,
        overlaying: 'y1',
      },
      xaxis1: {
        domain: [0, 0.97],
        anchor: 'y1',
        type: 'date',
        nticks: dateDiff(data[0].x[0], data[0].x[data[0].x.length - 1]) + 2,
        tickformat: '%b %d',
      },

      yaxis2: { domain: [0.34, 0.6], anchor: 'x2', side: 'right' },
      yaxis5: {
        domain: [0.34, 0.6],
        anchor: 'x2',
        visible: false,
        overlaying: 'y2',
      },
      xaxis2: {
        domain: [0.4, 0.97],
        anchor: 'y2',
        type: 'date',
        tickformat: checkMot('semaine_short') + '%W',
        tickmode: 'auto',
        nticks: data[2].x.length + 1,
      },

      yaxis3: { domain: [0.74, 0.97], anchor: 'x3', side: 'right' },
      yaxis6: {
        domain: [0.74, 1],
        anchor: 'x3',
        visible: false,
        overlaying: 'y3',
      },
      xaxis3: {
        domain: [0.4, 0.97],
        anchor: 'y3',
        type: 'date',
        tickformat: '%B',
        tickmode: 'auto',
        nticks: data[4].x.length + 2,
      },
      annotations: [
        {
          text:
            ((distanceParcourus / distanceFinale) * 100).toPrecision(2) + '%', //todo: variable %
          font: {
            size: 56,
          },
          showarrow: false,
          align: 'center',
          xanchor: 'left',
          x: 0.12,
          y: 0.85,
          xref: 'paper',
          yref: 'paper',
        },
        {
          text: checkMot('avancement_mensuel'),
          font: {
            size: 16,
            color: 'rgb(180, 180, 180)',
          },
          showarrow: false,
          align: 'right',
          xanchor: 'left',
          x: 0.4,
          y: 1.05,
          xref: 'paper',
          yref: 'paper',
        },
        {
          text: checkMot('avancement_hebdomadaire'),
          font: {
            size: 16,
            color: 'rgb(180, 180, 180)',
          },
          showarrow: false,
          align: 'right',
          xanchor: 'left',
          x: 0.4,
          y: 0.65,
          xref: 'paper',
          yref: 'paper',
        },
        {
          text: checkMot('avancement_journalier'),
          font: {
            size: 16,
            color: 'rgb(180, 180, 180)',
          },
          showarrow: false,
          align: 'right',
          xanchor: 'left',
          x: 0,
          y: 0.3,
          xref: 'paper',
          yref: 'paper',
        },
      ],
    };
    this.setState({
      data: data,
      layout: layout,
      dataJournalier: dataJournalier,
      dataProgressionJournalier: dataProgressionJournalier,
      dataHebdomadaire: dataHebdomadaire,
      dataProgressionHebdomadaire: dataProgressionHebdomadaire,
      dataMensuel: dataMensuel,
      dataProgressionMensuel: dataProgressionMensuel,
      courbeHistogrammeJournalier: courbeHistogrammeJournalier,
      courbeJour: courbeJour,
      courbeHistogrammeHebdomadaire: courbeHistogrammeHebdomadaire,
      courbeSemaine: courbeSemaine,
      courbeHistogrammeMensuel: courbeHistogrammeMensuel,
      courbeMois: courbeMois,
      gaugeDeProgression: gaugeDeProgression,
      table: table,
      distanceFinale: distanceFinale,
      distanceParcourus: distanceParcourus,
    });
  }

  render() {
    return (
      <BibliothequePlotly
        data={[...this.state.data]}
        layout={{
          ...this.state.layout,
          responsive: true,
          showlegend: false,
          ...this.props.viewobj_json_content,
        }}
        dimensionWidth={this.props.dimensionWidth}
        dimensionHeight={this.props.dimensionHeight}
        viewobj_json_content={this.props.viewobj_json_content}
        onClick={(data) => {
          let pn = '',
            xdata = '',
            ydata = '',
            xAxisNum = '';

          for (let i = 0; i < data.points.length; i++) {
            pn = data.points[i].pointNumber;
            xdata = data.points[i].x;
            ydata = data.points[i].y;
            xAxisNum = data.points[i].data.xaxis;
          }
          this.setState({
            dateSelectionne: xdata,
            valeurSelectionne: ydata,
            xAxisSelectionne: xAxisNum,
            indSelectionne: pn,
          });
          let dateSelectionne = xdata;
          let valeurSelectionne = ydata;
          let xAxisSelectionne = xAxisNum;

          let prevDateSelectionne = this.state.prevDateSelectionne;
          let prevXAxisSelectionne = this.state.prevXAxisSelectionne;

          let dataProgressionJournalier = this.state.dataProgressionJournalier;
          let courbeHistogrammeJournalier =
            this.state.courbeHistogrammeJournalier;
          let courbeSemaine = this.state.courbeSemaine;
          let courbeHistogrammeHebdomadaire =
            this.state.courbeHistogrammeHebdomadaire;
          let courbeMois = this.state.courbeMois;
          let courbeHistogrammeMensuel = this.state.courbeHistogrammeMensuel;
          let dataJournalier = this.state.dataJournalier;
          let distanceFinale = this.state.distanceFinale;
          let dataProgressionHebdomadaire =
            this.state.dataProgressionHebdomadaire;
          let courbeJour = this.state.courbeJour;
          let dataHebdomadaire = this.state.dataHebdomadaire;
          let dataProgressionMensuel = this.state.dataProgressionMensuel;
          let table = this.state.table;
          let dataMensuel = this.state.dataMensuel;
          let gaugeDeProgression = this.state.gaugeDeProgression;
          let distanceParcourus = this.state.distanceParcourus;

          let dataRetrievedLater = [...this.state.data];
          dataRetrievedLater[0] = { ...courbeHistogrammeJournalier };
          dataRetrievedLater[1] = { ...courbeJour };
          dataRetrievedLater[2] = { ...courbeHistogrammeHebdomadaire };
          dataRetrievedLater[3] = { ...courbeSemaine };
          dataRetrievedLater[4] = { ...courbeHistogrammeMensuel };
          dataRetrievedLater[5] = { ...courbeMois };
          dataRetrievedLater[6] = { ...gaugeDeProgression };
          dataRetrievedLater[7] = { ...table };

          if (
            prevDateSelectionne === dateSelectionne &&
            prevXAxisSelectionne === xAxisSelectionne
          ) {
            dateSelectionne = '';
            xAxisSelectionne = '';
          }
          // else if(prevXAxisSelectionne!==xAxisSelectionne && prevXAxisSelectionne!==""){
          //   this.setState({prevDateSelectionne:"", prevXAxisSelectionne:""});
          // }
          else {
            let filtreCourbeJourX = [];
            let filtreCourbeJourY = [];
            let filtreCourbeHistogrammeJournalierY = [];
            let filtreCourbeSemaineX = [];
            let filtreCourbeSemaineY = [];
            let filtreCourbeHistogrammeHebdomadaireY = [];
            let filtreCourbeMoisX = [];
            let filtreCourbeMoisY = [];
            let filtreCourbeHistogrammeMensuelY = [];
            switch (xAxisSelectionne) {
              case undefined:
                //Modification des données lors de la sélection d'un jour
                let surbrillanceJourSelectionne = new Array(
                  dataProgressionJournalier.x.length
                ).fill('rgba(238, 173, 1, 0.3)');
                surbrillanceJourSelectionne[
                  dataProgressionJournalier.x.indexOf(dateSelectionne)
                ] = 'rgba(238, 173, 1, 0.7)';
                // modification de la couleur du jour sélectionné
                dataRetrievedLater[0] = {
                  ...courbeHistogrammeJournalier,
                  marker: {
                    color: [...surbrillanceJourSelectionne], //couleur des histogramme
                  },
                };
                filtreCourbeSemaineX = [];
                filtreCourbeSemaineY = [];
                filtreCourbeHistogrammeHebdomadaireY = [];
                const semaineDuJourSelectionne =
                  getWeekNumberForPlotlyDate(dateSelectionne);
                const anneeDuJourSelectionne = dateSelectionne.substring(0, 3); //et année
                for (
                  let indDateX = 0;
                  indDateX < courbeSemaine.x.length;
                  indDateX++
                ) {
                  if (
                    getWeekNumberForPlotlyDate(courbeSemaine.x[indDateX]) ===
                      semaineDuJourSelectionne &&
                    courbeSemaine.x[indDateX].substring(0, 3) ===
                      anneeDuJourSelectionne
                  ) {
                    filtreCourbeSemaineX.push(courbeSemaine.x[indDateX]);
                    filtreCourbeSemaineY.push(courbeSemaine.y[indDateX]);
                    filtreCourbeHistogrammeHebdomadaireY.push(
                      courbeHistogrammeHebdomadaire.y[indDateX]
                    );
                  }
                }
                // filtreCourbeMois
                dataRetrievedLater[2] = {
                  ...courbeHistogrammeHebdomadaire,
                  x: filtreCourbeSemaineX,
                  y: filtreCourbeHistogrammeHebdomadaireY,
                };
                dataRetrievedLater[3] = {
                  ...courbeSemaine,
                  x: filtreCourbeSemaineX,
                  y: filtreCourbeSemaineY,
                };
                filtreCourbeMoisX = [];
                filtreCourbeMoisY = [];
                filtreCourbeHistogrammeMensuelY = [];
                const moisDuJourSelectionne = dateSelectionne.substring(0, 7); //et année
                for (
                  let indDateX = 0;
                  indDateX < courbeMois.x.length;
                  indDateX++
                ) {
                  if (
                    courbeMois.x[indDateX].substring(0, 7) ===
                    moisDuJourSelectionne
                  ) {
                    filtreCourbeMoisX.push(courbeMois.x[indDateX]);
                    filtreCourbeMoisY.push(courbeMois.y[indDateX]);
                    filtreCourbeHistogrammeMensuelY.push(
                      courbeHistogrammeMensuel.y[indDateX]
                    );
                  }
                }
                dataRetrievedLater[4] = {
                  ...courbeMois,
                  x: filtreCourbeMoisX,
                  y: filtreCourbeMoisY,
                };
                dataRetrievedLater[5] = {
                  ...courbeHistogrammeMensuel,
                  x: filtreCourbeMoisX,
                  y: filtreCourbeHistogrammeMensuelY,
                };

                //modification des valeurs de progression en fonction du jour sélectionné
                const filtreDistanceParcourusJour = Math.max(
                  ...dataJournalier.y.slice(
                    0,
                    dataProgressionJournalier.x.indexOf(dateSelectionne) + 1
                  )
                );
                distanceParcourus = filtreDistanceParcourusJour;
                dataRetrievedLater[6] = {
                  domain: { x: [0, 0.34], y: [0.74, 1] },
                  value: filtreDistanceParcourusJour,
                  type: 'indicator',
                  mode: 'gauge+number',
                  xaxis: 'x4',
                  yaxis: 'y4',
                  title: { text: 'Progression', align: 'left' },
                  number: {
                    // font:{
                    //   size:16
                    // },
                    // prefix: "<span style={fontSize='50px'}>5%</span><br>",
                    // suffix:" m"
                    prefix: '<br>',
                    suffix: ' m',
                  },
                  gauge: {
                    axis: { range: [0, distanceFinale] }, //distance finale arrondie pour voir le trait rouge final
                    // steps: [ //todo: information de phase
                    //   { range: [0, 250], color: "lightgray" },
                    //   { range: [250, 400], color: "gray" }
                    // ],
                    // threshold: { //todo: voir s'il y a une utilité (limite à atteindre)
                    //   line: { color: "red", width: 4 },
                    //   thickness: 0.75,
                    //   value: 490
                    // }
                  },
                };

                //recherche des maximuns
                const filtreJourMaxDataParMoisProgressionY = Math.max(
                  ...filtreCourbeHistogrammeMensuelY
                );
                const filtreJourMaxDataParSemaineProgressionY = Math.max(
                  ...filtreCourbeHistogrammeHebdomadaireY
                );
                const filtreJourMaxDataParJourProgressionY = valeurSelectionne;
                //calcul des moyennes
                const filtreJourMoyenDataParMoisProgressionY = average(
                  filtreCourbeHistogrammeMensuelY
                );
                const filtreJourMoyenDataParSemaineProgressionY = average(
                  filtreCourbeHistogrammeHebdomadaireY
                );
                const filtreJourMoyenDataParJourProgressionY =
                  valeurSelectionne;

                //Tableaux de maximuns et de moyennes
                const tableValuesJour = [
                  [
                    checkMot('mois') +
                      ' ' +
                      moisDuJourSelectionne.split('-')[1],
                    checkMot('semaine') + ' ' + semaineDuJourSelectionne,
                    checkMot('jour') + ' ' + dateSelectionne.substring(8),
                  ],
                  [
                    filtreJourMaxDataParMoisProgressionY,
                    filtreJourMaxDataParSemaineProgressionY,
                    filtreJourMaxDataParJourProgressionY,
                  ],
                  [
                    filtreJourMoyenDataParMoisProgressionY,
                    filtreJourMoyenDataParSemaineProgressionY,
                    filtreJourMoyenDataParJourProgressionY,
                  ],
                ];
                dataRetrievedLater[7] = {
                  layout: {
                    width: 500,
                    height: 500,
                  },
                  domain: {
                    x: [0, 0.34],
                    y: [0.3, 0.64],
                  },
                  type: 'table',
                  header: {
                    values: [
                      ['<b>' + dateSelectionne.substring(0, 4) + '</b>'],
                      ['<b>' + checkMot('max') + '</b> [m]'],
                      ['<b>' + checkMot('moyenne') + '</b> [m]'],
                    ],
                    align: 'center',
                    line: { width: 1, color: 'black' },
                    fill: { color: 'grey' },
                    font: { family: 'Arial', size: 12, color: 'white' },
                  },
                  cells: {
                    values: tableValuesJour,
                    align: 'center',
                    line: { color: 'black', width: 1 },
                    font: { family: 'Arial', size: 11, color: ['black'] },
                  },
                };
                break;

              case 'x2':
                //Modification des données lors de la sélection d'une semaine
                let surbrillanceSemaineSelectionne = new Array(
                  dataProgressionHebdomadaire.x.length
                ).fill('rgba(238, 173, 1, 0.3)');
                surbrillanceSemaineSelectionne[
                  dataProgressionHebdomadaire.x.indexOf(dateSelectionne)
                ] = 'rgba(238, 173, 1, 0.9)';
                // modification de la couleur du semaine sélectionnée
                dataRetrievedLater[2] = {
                  ...courbeHistogrammeHebdomadaire,
                  marker: {
                    color: [...surbrillanceSemaineSelectionne], //couleur des histogramme
                  },
                };
                //filtre des jour après sélection d'une semaine
                filtreCourbeJourX = [];
                filtreCourbeJourY = [];
                filtreCourbeHistogrammeJournalierY = [];
                const semaineSelectionne =
                  getWeekNumberForPlotlyDate(dateSelectionne);
                const anneeDeLaSemaineSelectionne = dateSelectionne.substring(
                  0,
                  3
                );
                for (
                  let indDateX = 0;
                  indDateX < courbeJour.x.length;
                  indDateX++
                ) {
                  if (
                    getWeekNumberForPlotlyDate(courbeJour.x[indDateX]) ===
                      semaineSelectionne &&
                    courbeJour.x[indDateX].substring(0, 3) ===
                      anneeDeLaSemaineSelectionne
                  ) {
                    filtreCourbeJourX.push(courbeJour.x[indDateX]);
                    filtreCourbeJourY.push(courbeJour.y[indDateX]);
                    filtreCourbeHistogrammeJournalierY.push(
                      courbeHistogrammeJournalier.y[indDateX]
                    );
                  }
                }
                // filtreCourbeMois
                dataRetrievedLater[0] = {
                  ...courbeHistogrammeJournalier,
                  x: filtreCourbeJourX,
                  y: filtreCourbeHistogrammeJournalierY,
                };
                dataRetrievedLater[1] = {
                  ...courbeJour,
                  x: filtreCourbeJourX,
                  y: filtreCourbeJourY,
                };

                filtreCourbeMoisX = [];
                filtreCourbeMoisY = [];
                filtreCourbeHistogrammeMensuelY = [];
                const moisDelaSemaineSelectionne = dateSelectionne.substring(
                  0,
                  7
                );
                for (
                  let indDateX = 0;
                  indDateX < courbeMois.x.length;
                  indDateX++
                ) {
                  if (
                    courbeMois.x[indDateX].substring(0, 7) ===
                    moisDelaSemaineSelectionne
                  ) {
                    filtreCourbeMoisX.push(courbeMois.x[indDateX]);
                    filtreCourbeMoisY.push(courbeMois.y[indDateX]);
                    filtreCourbeHistogrammeMensuelY.push(
                      courbeHistogrammeMensuel.y[indDateX]
                    );
                  }
                }
                dataRetrievedLater[4] = {
                  ...courbeMois,
                  x: filtreCourbeMoisX,
                  y: filtreCourbeMoisY,
                };
                dataRetrievedLater[5] = {
                  ...courbeHistogrammeMensuel,
                  x: filtreCourbeMoisX,
                  y: filtreCourbeHistogrammeMensuelY,
                };

                //modification des valeurs de progression en fonction de la semaine sélectionnée
                const filtreDistanceParcourusSemaine = Math.max(
                  ...dataHebdomadaire.y.slice(
                    0,
                    dataProgressionHebdomadaire.x.indexOf(dateSelectionne) + 1
                  )
                );
                distanceParcourus = filtreDistanceParcourusSemaine;
                dataRetrievedLater[6] = {
                  domain: { x: [0, 0.34], y: [0.74, 1] },
                  value: filtreDistanceParcourusSemaine,
                  type: 'indicator',
                  mode: 'gauge+number',
                  xaxis: 'x4',
                  yaxis: 'y4',
                  title: { text: 'Progression', align: 'left' },
                  number: {
                    // font:{
                    //   size:16
                    // },
                    // prefix: "<span style={fontSize='50px'}>5%</span><br>",
                    // suffix:" m"
                    prefix: '<br>',
                    suffix: ' m',
                  },
                  gauge: {
                    axis: { range: [0, distanceFinale] }, //distance finale arrondie pour voir le trait rouge final
                    // steps: [ //todo: information de phase
                    //   { range: [0, 250], color: "lightgray" },
                    //   { range: [250, 400], color: "gray" }
                    // ],
                    // threshold: { //todo: voir s'i 'il y a une utilité (limite à atteindre)
                    //   line: { color: "red", width: 4 },
                    //   thickness: 0.75,
                    //   value: 490
                    // }
                  },
                };

                //recherche des maximuns pour la semaine sélectionnée
                const filtreSemaineMaxDataParMoisProgressionY = Math.max(
                  ...filtreCourbeHistogrammeMensuelY
                );
                const filtreSemaineMaxDataParSemaineProgressionY =
                  valeurSelectionne;
                const filtreSemaineMaxDataParJourProgressionY = Math.max(
                  ...filtreCourbeHistogrammeJournalierY
                );
                //calcul des moyennes
                const filtreSemaineMoyenDataParMoisProgressionY = average(
                  filtreCourbeHistogrammeMensuelY
                );
                const filtreSemaineMoyenDataParSemaineProgressionY =
                  valeurSelectionne;
                const filtreSemaineMoyenDataParJourProgressionY = average(
                  filtreCourbeHistogrammeJournalierY
                );

                //Tableaux de maximuns et de moyennes
                const tableValuesSemaine = [
                  [
                    checkMot('mois') +
                      ' ' +
                      moisDelaSemaineSelectionne.split('-')[1],
                    checkMot('semaine') + ' ' + semaineSelectionne,
                    checkMot('journalier'),
                  ],
                  [
                    filtreSemaineMaxDataParMoisProgressionY,
                    filtreSemaineMaxDataParSemaineProgressionY,
                    filtreSemaineMaxDataParJourProgressionY,
                  ],
                  [
                    filtreSemaineMoyenDataParMoisProgressionY,
                    filtreSemaineMoyenDataParSemaineProgressionY,
                    filtreSemaineMoyenDataParJourProgressionY,
                  ],
                ];
                dataRetrievedLater[7] = {
                  layout: {
                    width: 500,
                    height: 500,
                  },
                  domain: {
                    x: [0, 0.34],
                    y: [0.3, 0.64],
                  },
                  type: 'table',
                  header: {
                    values: [
                      ['<b>' + dateSelectionne.substring(0, 4) + '</b>'],
                      ['<b>Max</b> [m]'],
                      ['<b>Moyen</b> [m]'],
                    ],
                    align: 'center',
                    line: { width: 1, color: 'black' },
                    fill: { color: 'grey' },
                    font: { family: 'Arial', size: 12, color: 'white' },
                  },
                  cells: {
                    values: tableValuesSemaine,
                    align: 'center',
                    line: { color: 'black', width: 1 },
                    font: { family: 'Arial', size: 11, color: ['black'] },
                  },
                };
                break;

              case 'x3':
                //Modification des données lors de la sélection d'un mois
                let surbrillanceMoisSelectionne = new Array(
                  dataProgressionMensuel.x.length
                ).fill('rgba(238, 173, 1, 0.3)');

                // if (xAxisSelectionne === prevXAxisSelectionne) {
                //     surbrillanceMoisSelectionne[indSelectionne] = 'rgba(238, 173, 1, 0.9)'
                // } else {
                //cas où les index ne correspondent plus si on change de graphe
                surbrillanceMoisSelectionne[
                  dataProgressionMensuel.x.indexOf(dateSelectionne)
                ] = 'rgba(238, 173, 1, 0.9)';
                // }
                // modification de la couleur du mois sélectionné
                dataRetrievedLater[4] = {
                  ...courbeHistogrammeMensuel,
                  marker: {
                    color: [...surbrillanceMoisSelectionne], //couleur des histogramme
                  },
                };
                //filtre des jour après sélection d'une semaine
                filtreCourbeJourX = [];
                filtreCourbeJourY = [];
                filtreCourbeHistogrammeJournalierY = [];
                const moisSelectionne = dateSelectionne.substring(0, 7);
                // const moisSelectionne = getWeekNumberForPlotlyDate(dateSelectionne)
                for (
                  let indDateX = 0;
                  indDateX < courbeJour.x.length;
                  indDateX++
                ) {
                  if (
                    courbeJour.x[indDateX].substring(0, 7) === moisSelectionne
                  ) {
                    filtreCourbeJourX.push(courbeJour.x[indDateX]);
                    filtreCourbeJourY.push(courbeJour.y[indDateX]);
                    filtreCourbeHistogrammeJournalierY.push(
                      courbeHistogrammeJournalier.y[indDateX]
                    );
                  }
                }
                // filtreCourbeJour
                dataRetrievedLater[0] = {
                  ...courbeHistogrammeJournalier,
                  x: filtreCourbeJourX,
                  y: filtreCourbeHistogrammeJournalierY,
                };
                dataRetrievedLater[1] = {
                  ...courbeJour,
                  x: filtreCourbeJourX,
                  y: filtreCourbeJourY,
                };

                filtreCourbeSemaineX = [];
                filtreCourbeSemaineY = [];
                filtreCourbeHistogrammeHebdomadaireY = [];
                for (
                  let indDateX = 0;
                  indDateX < courbeSemaine.x.length;
                  indDateX++
                ) {
                  if (
                    courbeSemaine.x[indDateX].substring(0, 7) ===
                    moisSelectionne
                  ) {
                    filtreCourbeSemaineX.push(courbeSemaine.x[indDateX]);
                    filtreCourbeSemaineY.push(courbeSemaine.y[indDateX]);
                    filtreCourbeHistogrammeHebdomadaireY.push(
                      courbeHistogrammeHebdomadaire.y[indDateX]
                    );
                  }
                }
                dataRetrievedLater[2] = {
                  ...courbeSemaine,
                  x: filtreCourbeSemaineX,
                  y: filtreCourbeSemaineY,
                };
                dataRetrievedLater[3] = {
                  ...courbeHistogrammeHebdomadaire,
                  x: filtreCourbeSemaineX,
                  y: filtreCourbeHistogrammeHebdomadaireY,
                };

                //modification des valeurs de progression en fonction du mois sélectionné
                const filtreDistanceParcourusMois = Math.max(
                  ...dataMensuel.y.slice(
                    0,
                    dataProgressionMensuel.x.indexOf(dateSelectionne) + 1
                  )
                );
                distanceParcourus = filtreDistanceParcourusMois;
                dataRetrievedLater[6] = {
                  domain: { x: [0, 0.34], y: [0.74, 1] },
                  value: filtreDistanceParcourusMois,
                  type: 'indicator',
                  mode: 'gauge+number',
                  xaxis: 'x4',
                  yaxis: 'y4',
                  title: { text: 'Progression', align: 'left' },
                  number: {
                    // font:{
                    //   size:16
                    // },
                    // prefix: "<span style={fontSize='50px'}>5%</span><br>",
                    // suffix:" m"
                    prefix: '<br>',
                    suffix: ' m',
                  },
                  gauge: {
                    axis: { range: [0, distanceFinale] }, //distance finale arrondie pour voir le trait rouge final
                    // steps: [ //todo: information de phase
                    //   { range: [0, 250], color: "lightgray" },
                    //   { range: [250, 400], color: "gray" }
                    // ],
                    // threshold: { //todo: voir s'i 'il y a une utilité (limite à atteindre)
                    //   line: { color: "red", width: 4 },
                    //   thickness: 0.75,
                    //   value: 490
                    // }
                  },
                };

                //recherche des maximuns pour le mois sélectionné
                const filtreMoisMaxDataParMoisProgressionY = valeurSelectionne;
                const filtreMoisMaxDataParSemaineProgressionY = Math.max(
                  ...filtreCourbeHistogrammeHebdomadaireY
                );
                const filtreMoisMaxDataParJourProgressionY = Math.max(
                  ...filtreCourbeHistogrammeJournalierY
                );
                //calcul des moyennes
                const filtreMoisMoyenDataParMoisProgressionY =
                  valeurSelectionne;
                const filtreMoisMoyenDataParSemaineProgressionY = average(
                  filtreCourbeHistogrammeHebdomadaireY
                );
                const filtreMoisMoyenDataParJourProgressionY = average(
                  filtreCourbeHistogrammeJournalierY
                );

                //Tableaux de maximuns et de moyennes
                const tableValuesMois = [
                  [
                    checkMot('mois') + ' ' + moisSelectionne.split('-')[1],
                    checkMot('hebdomadaire'),
                    checkMot('journalier'),
                  ],
                  [
                    filtreMoisMaxDataParMoisProgressionY,
                    filtreMoisMaxDataParSemaineProgressionY,
                    filtreMoisMaxDataParJourProgressionY,
                  ],
                  [
                    filtreMoisMoyenDataParMoisProgressionY,
                    filtreMoisMoyenDataParSemaineProgressionY,
                    filtreMoisMoyenDataParJourProgressionY,
                  ],
                ];
                dataRetrievedLater[7] = {
                  layout: {
                    width: 500,
                    height: 500,
                  },
                  domain: {
                    x: [0, 0.34],
                    y: [0.3, 0.64],
                  },
                  type: 'table',
                  header: {
                    values: [
                      ['<b>' + dateSelectionne.substring(0, 4) + '</b>'],
                      ['<b>Max</b> [m]'],
                      ['<b>Moyen</b> [m]'],
                    ],
                    align: 'center',
                    line: { width: 1, color: 'black' },
                    fill: { color: 'grey' },
                    font: { family: 'Arial', size: 12, color: 'white' },
                  },
                  cells: {
                    values: tableValuesMois,
                    align: 'center',
                    line: { color: 'black', width: 1 },
                    font: { family: 'Arial', size: 11, color: ['black'] },
                  },
                };
                break;
              default:
                break;
            }

            // let newData = [...this.state.data]
            // newData[0] = {
            //     ...this.state.data[0],
            //     x: this.state.data[0].x.slice(5,this.state.data[0].x.length),
            //     y: this.state.data[0].y.slice(5,this.state.data[0].y.length),
            // }
          }

          let newAnnotations = [...this.state.layout.annotations];
          newAnnotations[0] = {
            ...this.state.layout.annotations[0],
            text:
              ((distanceParcourus / distanceFinale) * 100).toPrecision(2) + '%', //ajout du pourcentage de progression
          };

          let ntickJour =
            dateDiff(
              dataRetrievedLater[0].x[0],
              dataRetrievedLater[0].x[dataRetrievedLater[0].x.length - 1]
            ) + 2; //nombre de graduations nommées

          let newAxisLayout = {
            yaxis1: { domain: [0, 0.3], anchor: 'x1', side: 'right' },
            yaxis4: {
              domain: [0, 0.3],
              anchor: 'x1',
              visible: false,
              overlaying: 'y1',
            },
            xaxis1: {
              domain: [0, 0.97],
              anchor: 'y1',
              type: 'date',
              tickformat:
                dataRetrievedLater[0].x.length > 7 ? '%b %d' : '%A %d',
              nticks: ntickJour,
            },

            yaxis2: { domain: [0.34, 0.6], anchor: 'x2', side: 'right' },
            yaxis5: {
              domain: [0.34, 0.6],
              anchor: 'x2',
              visible: false,
              overlaying: 'y2',
            },
            xaxis2: {
              domain: [0.4, 0.97],
              anchor: 'y2',
              type: 'date',
              tickformat: checkMot('semaine_short') + '%W',
              tickmode: 'auto',
              nticks: dataRetrievedLater[2].x.length + 1,
            },

            yaxis3: { domain: [0.74, 0.97], anchor: 'x3', side: 'right' },
            yaxis6: {
              domain: [0.74, 1],
              anchor: 'x3',
              visible: false,
              overlaying: 'y3',
            },
            xaxis3: {
              domain: [0.4, 0.97],
              anchor: 'y3',
              type: 'date',
              tickformat: '%B',
              tickmode: 'auto',
              nticks: dataRetrievedLater[4].x.length,
            },
          };

          this.setState({
            data: [...dataRetrievedLater],
            prevDateSelectionne: dateSelectionne,
            prevXAxisSelectionne: xAxisSelectionne,
            layout: {
              ...this.state.layout,
              ...newAxisLayout,
              annotations: [...newAnnotations],
            },
          });
        }}
      />
    );
  }
}

export default GrapheAvancementDetaille;
